import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as _DeprecatedColorFunctions from './asFunctions';
import * as _ColorVariables from './colorVariables';
// @ts-expect-error
import * as _transformColor from './transformColor';

/**
 * @deprecated this type is outdated and will be removed with v6.0.0
 */

/**
 * @deprecated this function is outdated and will be removed with v6.0.0
 */
export var transformColor = _transformColor;

/**
 * @deprecated this function is outdated and will be removed with v6.0.0
 */
export var hovered = _transformColor.hovered;

/**
 * @deprecated this function is outdated and will be removed with v6.0.0
 */
export var pressed = _transformColor.pressed;

/**
 * @deprecated this function is outdated and will be removed with v6.0.0
 */
export var ColorFunctions = _objectSpread(_objectSpread({}, _DeprecatedColorFunctions), _ColorVariables);
//# sourceMappingURL=index.js.map